import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

export const useStyles = makeStyles(() => ({
  container: {
    borderRadius: '4px',
    border: `1px solid ${colors.gray.l85}`,
    background: '#FFF',
    padding: '24px 24px 16px 24px',
    minHeight: '163px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  projectNameContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  projectDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
  },
  projectSectorContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  remainingDaysPill: {
    borderRadius: 20,
    padding: '2px 8px',
    backgroundColor: colors.yellow.l47,
    border: `1px solid ${colors.yellow.l46}`,
  },
}));
